/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * A URI reference to human-readable documentation for the error.
 */
export type ProblemInternalServerErrorType = '/internal-server-error';
export const ProblemInternalServerErrorType = {
    InternalServerError: '/internal-server-error',
} as const;
